import * as React from "react";

import type { GridPayload } from "../../grid-settings/types";

export interface ListTableProps {
  gridSettingPayload?: GridPayload;
  onCreateExample?: () => void;
  onViewExample?: (exampleId: string) => void;
  onEditExample?: (exampleId: string) => void;
  onDeleteExample?: (exampleId: string) => void;
  selectedRowId?: string;
  onTableReady?: (table: unknown) => void;
  children?: React.ReactNode;
}

const ListTable: React.FC<ListTableProps> = ({ onTableReady, children }) => {
  React.useEffect(() => {
    if (onTableReady) {
      onTableReady({ ready: true });
    }
  }, [onTableReady]);

  return (
    <div className="flex h-full w-full items-center justify-center">
      {children ?? "Provide your table implementation here."}
    </div>
  );
};

export default ListTable;
